<template>
  <div id="Call" style="height:100%;margin:0px;padding:0px">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <a-menu v-model="current" mode="horizontal">
      <a-menu-item key="callwork" to="/">
        <router-link class="navlink" to="/call">
          <a-icon type="mail" />外呼工作台
        </router-link>
      </a-menu-item>
      <a-menu-item key="report" to="/report">
        <router-link class="navlink" to="/call/report">
          <a-icon type="bar-chart" />组员报表
        </router-link>
      </a-menu-item>
      <template v-if="isAdmin()">
        <a-menu-item key="dashboard" to="/dashboard">
          <router-link class="navlink" to="/call/dashboard">
            <a-icon type="bar-chart" />总报表
          </router-link>
        </a-menu-item>
      </template>
      <a-menu-item key="logout" style="float:right" @click="logout">
        <a-icon type="logout" />退出登陆
      </a-menu-item>
      <a-menu-item
        key="callsetting"
        style="float:right"
        @click="showCallSettingModel"
      >
        <a-icon type="setting" />外呼设置
      </a-menu-item>
      <!-- TODO:查录音功能 -->
      <a-menu-item
        key="recordhistory"
        style="float:right"
        @click="showRecordHistoryModel"
      >
        <a-icon type="customer-service" />查通话录音
      </a-menu-item>
    </a-menu>
    <ModelCallSetting />
    <ModelRecordHistory />
    <router-view />
  </div>
</template>

<script>
import { logoutWithCleanLocalStorage } from '@/api/axios.js'
import ModelCallSetting from '@/views/components/models/ModelCallSetting.vue'
import ModelRecordHistory from '@/views/components/models/ModelRecordHistory.vue'
export default {
  name: 'Call',
  data () {
    return {
      current: ['callwork']
    }
  },
  components: {
    ModelCallSetting,
    ModelRecordHistory
  },
  methods: {
    logout () {
      console.log('logout')
      logoutWithCleanLocalStorage()
    },
    showCallSettingModel () {
      console.log('show isShowCallSettingModel')
      this.$store.state.isShowCallSettingModel = true
    },
    showRecordHistoryModel () {
      console.log('show isShowRecordHistoryModel')
      this.$store.state.isShowRecordHistoryModel = true
    },
    isAdmin: function () {
      if (localStorage.isAdmin === '1') {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style>
#navlink {
  float: left;
  color: #333333;
}
</style>
